<template>
    <div>
      <strong>{{ dynamicPart }}</strong> {{ staticPart }}
    </div>
  </template>
  
  <script>
  export default {
    props: ['dynamicPart', 'staticPart']
  }
  </script>
  